function sortCollectionPointsByDistance(collectionPoints) {
  return collectionPoints.sort((a, b) => a.distanceInMiles - b.distanceInMiles);
}

export default sortCollectionPointsByDistance;
